<template>
  <div class="recharge">
    <Header :title="title" :right-content="rightContent" />
    <div id="content">
      <div class="layout">
        <div v-if="!accountSatus" class="prompt">
          <img src="@/assets/images/template/a_top_remind.png">
          <span>当前账户为<em>{{ accountTxt }}账户</em>，首次最低存款金额<em v-if="isWayAmountList">${{ minAmount }}</em><em v-else>￥{{
            Utils.roundUp(
              Utils.accMul(parseFloat(minAmount), rate),
              0
            ).toFixed(2)
          }}</em></span>
        </div>
        <div class="select-account-container">
          <SelectAccount @onConfirmAccount="onConfirmAccount" />
        </div>
        <div>
          <DepositCampaignMarquee />
        </div>
        <div class="payWay">
          <div class="re_title"><span>支付方式</span></div>
          <div class="payWayList">
            <ul id="payWayList">
              <li v-for="(item, index) in payList" :key="'paylist-' + index" :class="{ checked: isPay == index }">
                <div class="item" @click="checkPayType(item, index)">
                  <p>
                    <img
                      :src="require('@/assets/images/recharge/pay_icon/' +
                        payLogo[index] +
                        '.png')"
                    >{{ item.paymentGatewayName }}
                  </p>
                  <span />
                </div>
                <ul
                  v-if="(['ivi_electronic', 'ivi_usdt'].includes(payCode) || String(item.id).includes('USDT')) &&
                    isPay == index &&
                    bankDictList.length > 0"
                >
                  <li
                    v-for="(subItem, subIndex) in bankDictList"
                    :key="'bank-dict-list-' + subItem.name"
                    :class="{ checked: isWayAmount == subIndex }"
                  >
                    <div class="item" @click="checkWayType(subItem, subIndex)">
                      <p>
                        {{ subItem.name
                        }}<em v-if="subItem.usageState == 'news'">上次使用</em>
                      </p>
                      <i />
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
            <div v-if="originalPayList.length > 3">
              <a v-if="isOpen" @click="clickOpen">点击查看更多</a>
              <a v-else @click="clickClose">收起</a>
            </div>
          </div>
        </div>
        <div
          v-if="!usdtPayIDsMap['USDT - 1'].includes(payID) && !usdtPayIDsMap['USDT - 3'].includes(payID) && !String(payID).includes('USDT') "
          class="amount"
        >
          <div v-if="isWayAmountList" class="re_title">
            <span>存款金额<em>（美元）</em></span>
          </div>
          <div v-else class="re_title">
            <span>存款金额<em>（人民币）</em></span>
            <p v-if="!isInput && originalWayAmountList.length > 8">
              <i v-if="isOpenWay" @click="clickOpenWay">更多金额</i>
              <i v-else @click="clickCloseWay">收起</i>
            </p>
          </div>
          <div
            v-if="isInput && !otcIDs.includes(payID) && !mdMatchPayIDs.includes(payID) && !mdTraditionalIDs.includes(payID) && !deskZhongYiIDs.includes(payID) && !mdPayIDsMap['200073'].includes(payID)"
            id="inputAmount"
            class="inputAmount"
            @mouseenter="onMouseOver"
            @mouseleave="onMouseOut"
          >
            <span>{{ isWayAmountList ? "$" : "￥" }}</span>
            <input
              v-if="isWayAmountList"
              v-model="amount"
              type="number"
              :placeholder="amountPlaceholder"
              onkeyup="(this.v=function(){this.value=this.value.replace(/[^0-9-]+\.\d+/,'');}).call(this)"
              onblur="this.v();"
            >
            <input
              v-else
              v-model="wayAmount"
              type="number"
              :placeholder="amountPlaceholder"
              onkeyup="(this.v=function(){this.value=this.value.replace(/[^0-9-]+\.\d+/,'');}).call(this)"
              onblur="this.v();"
            >
            <p>免手续费</p>
          </div>
          <div class="amountList">
            <ul v-if="isWayAmountList">
              <li
                v-for="(amountOption, index) in filteredAmountList()"
                :key="`amount-option-${index}`"
                :ref="'amount-list-' + index"
                :class="{ checked: isTrue == index }"
                style="flex: 1"
                :data-index="index"
                @click="checkAmount(amountOption, index)"
              >
                <span>{{ amountOption.fixedAmount }}</span>
                <p v-if="amountOption.grantAmount != ''">
                  赠${{ amountOption.grantAmount }}
                </p>
              </li>
            </ul>
            <ul v-else>
              <li
                v-for="(amountOption, index) in filteredWayAmountList()"
                :key="`amount-option-cny-${index}`"
                :class="{ checked: isTrue == index }"
                @click="checkAmount(amountOption, index)"
              >
                <span>{{ amountOption }}</span>
              </li>
              <!-- <li
                v-if="otcIDs.includes(payID)"
                :key="'amount-option-cny-3000'"
                :class="{ checked: isTrue == wayAmountList.length }"
                @click="checkAmount('3000', wayAmountList.length)"
              >
                <span>≥3000</span>
              </li> -->
            </ul>
          </div>
          <div
            v-if="otcIDs.includes(payID) || mdTraditionalIDs.includes(payID)"
            id="inputAmount"
            class="inputAmount"
            @mouseenter="onMouseOver"
            @mouseleave="onMouseOut"
          >
            <span>￥</span>
            <input
              v-model="wayAmount"
              type="number"
              :placeholder="otcIDs.includes(payID) ? '请输入存款金额' : '请输入等于或大于3000存款金额'"
              onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
            >
            <p>免手续费</p>
          </div>
          <!--<div class="prompt" v-if="bonus&&bonus!=''"><img src="@/assets/images/template/a_top_remind.png"/><span>当前入金可享赠金{{bonus}}美元，预计{{Utils.roundUp(Utils.accMul(bonus,rate),0).toFixed(2)}}人民币</span></div>-->
        </div>
        <div class="btnList">
          <!-- ivi_deposite with usd dollar and usdterc -->
          <div v-if="amount != '' && isWayAmountList">
            <div class="titBtn">
              <!-- <span>实时存款金额换算（人民币）</span> -->
              <span>实时存款金额换算（{{
                getDisplayCurrencyText(displayCurrency)
              }}）</span>
              <p>实时汇率: 1：{{ rate }}</p>
            </div>
            <div class="rateCon">
              <p>{{ amount }}*{{ rate }}≈</p>
              <span v-if="usdtPayIDsMap['USDT - 2'].includes(payID)">{{
                Math.round(Utils.accMul(amount, rate) * 100) / 100
              }}</span>
              <span v-else>
                {{ Utils.roundUp(Utils.accMul(amount, rate), 0).toFixed(2) }}
              </span>
              <!-- <p>人民币</p> -->
              <p>{{ getDisplayCurrencyText(displayCurrency) }}</p>
            </div>
          </div>
          <!-- deposite CNY -->
          <div v-else-if="wayAmount != ''">
            <div class="titBtn">
              <span>实时存款金额换算（美元）</span>
              <p>实时汇率: 1：{{ rate }}</p>
            </div>
            <div class="rateCon">
              <p>{{ (otcIDs.includes(payID) || mdTraditionalIDs.includes(payID) || iviMatchPayIDs.includes(payID)) ?
                wayAmount : Utils.roundUp(wayAmount, 0).toFixed(2) }}/{{ rate }}≈</p>
              <span>{{ Utils.accDiv(wayAmount, rate).toFixed(2) }}</span>
              <!-- <p>{{displayCurrency === 'USDT' ? 'USDT' : '美元'}}</p> -->
              <p>美元</p>
            </div>
          </div>
          <div v-if="isErrMessage">
            <span v-if="isWayAmountList" class="errMessage">最小存款金额为{{ minAmount }}美元</span>
            <span v-else class="errMessage">最小存款金额为{{
              Utils.roundUp(
                Utils.accMul(parseFloat(minAmount), rate),
                0
              ).toFixed(2)
            }}人民币</span>
          </div>
          <div
            v-track-event="{
              category: '存款',
              action: '确认存款',
              label: 'M端用户中心',
            }"
            class="submit"
            :class="isSubmitEnabled()
              ? 'suc'
              : ''
            "
            @click="submit"
          >
            <a>确认存款</a>
          </div>
          <div
            class="agreement"
            style="
              display: flex;
              flex-direction: column;
              align-items: flex-start;"
          >
            <p>
              点击确认即表示同意<em @click="rechargeNoticePop">《存款须知》</em>
            </p>
            <p>
              1.
              不接受信用卡及非本人入金，如经发现，所存入之资金将可能扣取10%手续费并冻结账户。
            </p>
            <p>
              2.
              为核对为本人入金，我司有机会请客户提供个人入金证明，如转账APP的截图。
            </p>
            <p>
              3.
              每次入金必须登录用户中心以获取最新的时效性收款账号，如以过去旧有收款账号操作入金，其所存入金额或无法追回，敬请留意。
            </p>
          </div>
        </div>
      </div>
      <Chat />
    </div>
    <!--存取款流程-->
    <DepositAndWithdrawal
      v-if="isDepositAndWithdrawal"
      :key="depositAndWithdrawalKey"
      :this-page-type="pageType"
      :source="source"
      :money-status="moneyStatus"
      @getFaceVal="getFaceVal"
    />
    <!--点击确认再次验证人脸-->
    <ButtonCertify v-if="isButtonCertify" :source="source" :button-data="buttonData" :money-status="moneyStatus" />
    <!--快捷支付列表-->
    <div v-if="isBankDictListPop" class="popFixed">
      <div class="masking" @click="closeBankDictListPop" />
      <div class="bottomCon">
        <div class="item">
          <span>转账方式</span>
          <ul>
            <li
              v-for="(item, index) in bankDictList"
              :key="'bank-dict-list-' + index"
              :class="{ checked: isDict == index }"
            >
              <div class="itemCheck" @click="checkDictType(item, index)">
                <p v-if="payCode == 'chinaway' || payCode == 'chinaway_cashier'">
                  <img
                    :src="require('@/assets/images/recharge/bank_icon/' +
                      dictPayLogo[index] +
                      '.png')"
                  >{{ item.name }}
                </p>
                <p v-else>
                  <img
                    :src="require('@/assets/images/recharge/pay_icon/' +
                      dictPayLogo[index] +
                      '.png')"
                  >{{ item.name }}
                </p>
                <em />
              </div>
            </li>
          </ul>
        </div>
        <div class="errMessage">
          <span v-if="isDictExplain">注：实际转账方式必须与所选方式一致，否则不能及时到账。</span>
          <span v-if="isDictErrMessage">最小存款金额为{{ minAmount }}美元</span>
        </div>
        <div class="btnCon">
          <a class="submit" @click="submitDict">确定</a>
        </div>
      </div>
    </div>

    <!-- <div v-if="showSelectAccountPop" class="popFixed">
      <div class="masking" @click="closeSelectAccountPop" />
      <div class="bottomCon">
        <div class="item">
          <span>存款账号</span>
          <ul>
            <li class="checked">
              <div class="itemCheck">
                <p>81020140 (CFD)</p>
                <em />
              </div>
            </li>
          </ul>
        </div>
        <div class="btnCon">
          <a class="submit" @click="closeSelectAccountPop">确定</a>
        </div>
      </div>
    </div> -->
    <!--存款须知-->
    <div v-if="isRechargeNoticePop" class="popFixed">
      <div class="masking" @click="rechargeNoticePop" />
      <div class="tcCon">
        <div class="item">
          <span>存款须知</span>
          <div class="explain">
            <p class="txtLeft">
              1、请注意，所有已兑现款均会即时显示于本公司交易系统的账户报表内，本公司不会另行发出入账通知书。
            </p>
            <p class="txtLeft">
              2、为防止洗黑钱活动，在任何情况下，本公司均不会接受非本人（第三方）的存款，存入资金来自本人提供的存款银行卡账户，本人为账户持有人及该资金的最终实益拥有人，并确认存入资金与任何非法活动无关。
            </p>
            <p class="txtLeft">
              3、如发现客户利用非本人（第三方）或信用卡进行存款，本公司将立即进行退款，退款所引致的取款手续费及其他费用（如有）均由客户承担。
            </p>
            <p class="txtLeft">4、请注意，本公司不接受信用卡存款。</p>
            <p class="txtLeft">5、本公司的指定账户货币为美元。</p>
            <p class="txtLeft">
              6、非账户货币的存款，均按照第三方网上支付平台或银行市场汇率兑换为账户货币，经兑换后的存款金额，可能与原定存款金额有所差异。汇率以当时第三方网上支付平台兑换价格为准。
            </p>
            <p class="txtLeft">
              7、本公司须不时按照监管机构规定进行尽职审查，若客户未能提交个人身份证明，存款证明或银行账户数据不全，有可能导致交易账户到账的延误，敬请客户留意。
            </p>
          </div>
        </div>
        <div class="btnCon only">
          <span @click="rechargeNoticePop">知道了</span>
        </div>
      </div>
    </div>
    <!--存款失败-->
    <div v-if="isRechargeErr" class="popFixed">
      <div class="masking" @click="closeRechargeErr" />
      <div class="tcCon">
        <div class="item">
          <p>{{ rechargeErrTxt }}</p>
        </div>
        <div class="btnCon only">
          <span @click="closeRechargeErr">我知道了</span>
        </div>
      </div>
    </div>
    <!--威易支付银行卡列表为空-->
    <div v-if="isChinawayPop" class="popFixed">
      <div class="masking" @click="closeChinaway" />
      <div class="tcCon">
        <div class="pos_right">
          <span @click="getHoldBank">查看支持的银行卡</span>
        </div>
        <div class="item">
          <p>为了您的资金安全，请先绑定可用银行卡</p>
        </div>
        <div class="btnCon only">
          <span @click="goAddBankCard">去绑定</span>
        </div>
      </div>
    </div>
    <!--支持银行卡列表-->
    <holdBankList v-if="isHoldBank" :show="isHoldBank" :bank-list="bankList" @cancel="closeHoldBankPop" />
    <AlertPop
      :title="`${alertPaymentGatewayName} 温馨提示`"
      :model="showAlertPop"
      :content="alertPopContent"
      :button1-txt="alertPopCustomized.button1Txt"
      :use-slot="alertPopUseSlot"
      @alertOnClose="alertBoxClose"
    >
      <div v-if="alertPopUseSlot">
        <!-- <ChinawayOnStopAlert v-if="alertPopContent === 'chinaway_onestop'" /> -->
        <UsdtAlert v-if="alertPopContent === 'ivi_usdt'" :token-standard="payName" />
        <ChinawayOTCAlert
          v-else-if="alertPopContent === 'chinaway_otc'"
          :pay-id="payID"
          :way-amounts="alertWayAmounts"
        />
        <ElectronicAlert v-else-if="alertPopContent === 'ivi_electronic'" />
        <IPayAlert v-else-if="alertPopContent === 'usdt2'" :pay-currency="alertPopCustomized.payCurrency" />
        <MdAlert v-else-if="alertPopContent === 'md'" />
        <Md200073Alert v-else-if="alertPopContent === 'md200073'" />
        <Usdt3Alert v-else-if="alertPopContent === 'usdt3'" :min-deposit-amt="minAmount" />
        <WechatPayAlert v-else-if="alertPopContent === 'wechatPay'" />
      </div>
    </AlertPop>
    <div v-if="showHasManyDepositAlertPop" class="showHasManyDepositAlertPop">
      <AlertPop
        :model="showHasManyDepositAlertPop"
        :content="'存款操作多次未成功，可联系客服查询存款情况'"
        :button1-txt="'联系客服'"
        :button2-txt="'知道了'"
        @button1Evt="openLive800"
        @alertOnClose="showHasManyDepositAlertPop = false"
      />
    </div>
    <div v-if="showAddBankCardAlertPop">
      <AlertPop
        :model="showAddBankCardAlertPop"
        :content="'为了您的账户资金安全\n存款请先添加一张银行卡'"
        :button1-txt="'去添加'"
        @button1Evt="goAddBankCard"
        @alertOnClose="showAddBankCardAlertPop = false"
      />
    </div>
    <div>
      <DepositPayMethodWarningPopup ref="depositPayMethodWarningPopup" />
    </div>
  </div>
</template>

<script>
require('@/assets/css/recharge.css')
import api from '@/plugins/api'
import utils from '@/utils/tradeDataUtil'
import { mapState } from 'vuex'
import { getDisplayCurrencyText } from '@/utils/helper'

export default {
  name: 'Recharge',
  components: {
    Header: () => import(/* webpackChunkName: "header" */ '@/view/module/Header.vue'),
    DepositAndWithdrawal: () => import(/* webpackChunkName: "depositAndWithdrawal" */ '@/view/module/DepositAndWithdrawal.vue'),
    ButtonCertify: () => import(/* webpackChunkName: "buttonCertify" */ '@/view/module/ButtonCertify.vue'),
    Chat: () => import(/* webpackChunkName: "chat" */ '@/view/module/Chat.vue'),
    holdBankList: () => import(/* webpackChunkName: "holdBankList" */ '@/view/bankCard/holdBankList.vue'),
    AlertPop: () => import(/* webpackChunkName: "alertPop" */ '@/view/module/AlertPop.vue'),
    // ChinawayOnStopAlert: () => import(/* webpackChunkName: "chinawayOnStopAlert" */ '@/view/module/ChinawayOnStopAlert.vue'),
    ChinawayOTCAlert: () => import(/* webpackChunkName: "chinawayOTCAlert" */ '@/view/textModule/ChinawayOTCAlert.vue'),
    UsdtAlert: () => import(/* webpackChunkName: "usdtAlert" */ '@/view/textModule/UsdtAlert.vue'),
    ElectronicAlert: () => import(/* webpackChunkName: "electronicAlert" */ '@/view/textModule/ElectronicAlert.vue'),
    IPayAlert: () => import(/* webpackChunkName: "iPayAlert" */ '@/view/textModule/IPayAlert.vue'),
    MdAlert: () => import(/* webpackChunkName: "mdAlert" */ '@/view/textModule/MdAlert.vue'),
    Md200073Alert: () => import(/* webpackChunkName: "md200073Alert" */ '@/view/textModule/Md200073Alert.vue'),
    Usdt3Alert: () => import(/* webpackChunkName: "usdt3Alert" */ '@/view/textModule/Usdt3Alert.vue'),
    SelectAccount: () => import(/* webpackChunkName: "selectAccount" */ '@/view/module/SelectAccount.vue'),
    WechatPayAlert: () => import(/* webpackChunkName: "wechatPayAlert" */ '@/view/textModule/WechatPayAlert.vue'),
    DepositCampaignMarquee: () => import(/* webpackChunkName: "depositCampaignMarquee" */ '@/view/module/DepositCampaignMarquee.vue'),
    DepositPayMethodWarningPopup: () => import(/* webpackChunkName: "depositPayMethodWarningPopup" */ '@/view/textModule/DepositPayMethodWarningPopup.vue')
  },
  data() {
    const u = navigator.userAgent
    return {
      title: '存款',
      rightContent: 'recharge',
      Utils: utils,
      getDisplayCurrencyText: getDisplayCurrencyText,
      isTrue: -1,
      isPay: null,
      bonus: '', // 赠金
      bonusMin: [], // 赠金最小值
      amount: '', // 存款金额
      amountList: '', // 存款金额列表
      upperLimit: '',
      lowerLimit: '',
      ruleList: '', // 输入规则
      payList: [], // 支付方式列表
      originalPayList: '', // 原始支付方式列表
      payLogoList: process.env.VUE_APP_PAYLOGO, // 支付方式logo
      payLogo: [],
      dictPayLogoList: process.env.VUE_APP_DICTPAYLOGO, // 快捷支付方式logo
      dictPayLogo: [],
      isDict: 0,
      isBankDictListPop: false,
      bankDictList: '', // 快捷支付支付方式列表
      bqwaytype: '', // 快捷方式支付方式序号
      isErrMessage: false,
      isDictExplain: true,
      isDictErrMessage: false,
      isDepositAndWithdrawal: true,
      moneyStatus: 'recharge',
      source: 'recharge',
      payCode: '', // 支付方式code
      payDictCode: '', // 快捷支付方式code
      rate: '', // 汇率，
      accountLevelList: JSON.parse(process.env.VUE_APP_LEVEL), // 账户列表
      accountTxt: '', // 账户名
      minAmount: '', // 不同账户最小存款金额
      amountPlaceholder: '',
      isRechargeNoticePop: false,
      payID: '', // 支付方式(支付id)
      payName: '', // 支付方式名称
      accountSatus: true, // 账号状态
      isRechargeErr: false,
      rechargeErrTxt: '',
      rechargeErrCallback: null,
      buttonData: '',
      isButtonCertify: false,
      isChinawayPop: false,
      isHoldBank: false,
      bankList: '',
      bankAccountNumber: '', // 威易支付银行卡号
      isHasMicrpay: -1,
      isInput: true,
      wayAmountList: [], // 新支付存款金额列表（人民币）
      originalWayAmountList: [], // 原始新支付存款金额列表（人民币）
      isWayAmountList: true,
      isWayAmount: -1,
      wayAmount: '', // 新支付存款金额（人民币）
      payCurrency: '', // 新支付币种
      isOpen: true, // 支付列表是否展开
      isOpenWay: true, // 新支付存款金额列表是否展开
      accountGroup: -1, // 账号组别(0：测试组)
      isAndroid: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
      isIOS: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
      isFaceValidate: true, // 是否需要人脸识别
      appObj: '',
      displayCurrency: 'CNY',
      allowSubmit: true,
      showAlertPop: false,
      alertPaymentGatewayName: '',
      alertPopUseSlot: false,
      alertPopContent: '',
      alertPopCustomized: {
        button1Txt: '',
        payCurrency: ''
      },
      otcIDs: process.env.VUE_APP_OTC_IDS.split(',').map(id => Number(id)),
      mdMatchPayIDs: process.env.VUE_APP_MD_MATCH_PAY_IDS.split(',').map(id => Number(id)),
      mdTraditionalIDs: process.env.VUE_APP_MD_TRADITIONAL_IDS.split(',').map(id => Number(id)),
      mdWayAmounts: [],
      alertWayAmounts: [],
      iviMatchPayIDs: process.env.VUE_APP_IVI_MATCH_PAY_IDS.split(',').map(id => Number(id)),
      deskZhongYiIDs: process.env.VUE_APP_DESKZHONGYI_IDS.split(',').map(id => Number(id)),
      usdtPayIDsStr: process.env.VUE_APP_USDT_PAY_IDS,
      mdPayIDsStr: process.env.VUE_APP_MD_PAY_IDS,
      showHasManyDepositAlertPop: false,
      mdAltWayAmountsStr: process.env.VUE_APP_MD_ALT_WAY_AMOUNTS,
      showAddBankCardAlertPop: false,
      depositAndWithdrawalKey: 0,
      wechatPayIDs: process.env.VUE_APP_WECHAT_PAY_IDS.split(',').map(id => Number(id))
    }
  },
  computed: {
    ...mapState([
      'user',
      'platform',
      'currency',
      'rechargeData',
      'tokenCookie',
      'pageType',
      'sourceType'
    ]),
    depositParam: {
      get() {
        return {
          platform: this.platform,
          payMethod: this.payID,
          // amount: this.isWayAmountList
          //   ? this.amount
          //   : utils.accDiv(this.wayAmount, this.rate).toFixed(2),
          amount: this.isWayAmountList
            ? this.amount
            : this.wayAmount,
          depositCurrency: this.currency,
          bqwaytype: this.bqwaytype,
          isFaceValidate: this.isFaceValidate,
          calculatedCurrency: 'CNY'
        }
      }
    },
    filteredAmountList: function() {
      return () => {
        if (this.amountList) {
          // if (['chinaway', 'micrpay'].includes(this.payCode)) {
          //   return this.amountList.filter(ele => Number(ele.fixedAmount) > 300)
          // } else {

          var filteredAmounts = this.amountList
          if (this.upperLimit && this.upperLimit != '') {
            filteredAmounts = filteredAmounts.filter(amount => Number(amount.fixedAmount) <= this.upperLimit)
          }
          if (this.lowerLimit && this.lowerLimit != '') {
            filteredAmounts = filteredAmounts.filter(amount => Number(amount.fixedAmount) >= this.lowerLimit)
          }
          return filteredAmounts
          // }
        } else {
          return []
        }
      }
    },
    filteredWayAmountList: function() {
      return () => {
        if (this.wayAmountList) {
          if (['ivi_electronic'].includes(this.payCode)) {
            return this.wayAmountList.filter(ele => Number(ele) >= 200)
          } else {
            return this.wayAmountList
          }
        } else {
          return []
        }
      }
    },
    usdtPayIDsMap: function() {
      const usdtPayIDsObj = JSON.parse(this.usdtPayIDsStr)
      Object.keys(usdtPayIDsObj).forEach(function(key) {
        usdtPayIDsObj[key] = String(usdtPayIDsObj[key]).split(',').map(id => Number(id))
      })
      return usdtPayIDsObj
    },
    usdtPayIDsList: function() {
      let payMethodIDs = []
      const usdtPayIds = this.usdtPayIDsMap
      Object.keys(usdtPayIds).forEach(function(key) {
        payMethodIDs = [...payMethodIDs, ...usdtPayIds[key]]
      })
      return payMethodIDs
    },
    mdPayIDsMap: function() {
      const mdPayIDsObj = JSON.parse(this.mdPayIDsStr)
      Object.keys(mdPayIDsObj).forEach(function(key) {
        mdPayIDsObj[key] = String(mdPayIDsObj[key]).split(',').map(id => Number(id))
      })
      return mdPayIDsObj
    },
    mdPayIDsList: function() {
      let payMethodIDs = []
      const mdPayIds = this.mdPayIDsMap
      Object.keys(mdPayIds).forEach(function(key) {
        payMethodIDs = [...payMethodIDs, ...mdPayIds[key]]
      })
      return payMethodIDs
    },
    mdAltWayAmountsMap: function() {
      const mdAltWayAmountsObj = JSON.parse(this.mdAltWayAmountsStr)
      Object.keys(mdAltWayAmountsObj).forEach(function(key) {
        mdAltWayAmountsObj[key] = String(mdAltWayAmountsObj[key]).split(',').map(id => Number(id))
      })
      return mdAltWayAmountsObj
    }
  },
  watch: {
    amount: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue && newValue !== '') {
          if (isNaN(newValue) || String(newValue).indexOf('-') >= 0) { this.amount = parseFloat(newValue.replace('-', '')).toFixed(2) }
          if (newValue.toString().split('.')[1]) {
            const fixed = newValue.toString().split('.')[1].length
            if (fixed > 2) {
              newValue
                .toString()
                .split('.')[1]
                .slice(0, 2)
              newValue =
                newValue.toString().split('.')[0] +
                '.' +
                newValue
                  .toString()
                  .split('.')[1]
                  .slice(0, 2)
              this.amount = parseFloat(newValue).toFixed(2)
            }
          }
          if (
            this.ruleList &&
            this.ruleList instanceof Array &&
            this.ruleList.length > 0
          ) {
            for (const i in this.ruleList) {
              if (this.ruleList[i].gtBounds !== '') {
                if (this.ruleList[i].ltBounds !== '') {
                  if (newValue >= parseFloat(this.ruleList[i].gtBounds)) {
                    if (newValue < parseFloat(this.ruleList[i].ltBounds)) {
                      if (this.ruleList[i].amount !== '') { this.bonus = this.ruleList[i].amount }
                    } else {
                      if (this.ruleList[i].amount !== '') { this.bonus = this.ruleList[i].amount }
                    }
                  }
                } else {
                  if (newValue >= parseFloat(this.ruleList[i].gtBounds)) {
                    if (this.ruleList[i].amount !== '') { this.bonus = this.ruleList[i].amount }
                  }
                }
              }
            }
          }
          if (newValue < parseFloat(this.bonusMin[0])) this.bonus = ''
          if (this.isWayAmountList) {
            if (this.amountList) {
              let flag = false
              for (const i in this.amountList) {
                if (
                  parseFloat(newValue) ===
                  parseFloat(this.amountList[i].fixedAmount)
                ) {
                  this.isTrue = i
                  flag = true
                }
              }
              if (!flag) this.isTrue = -1
            }
          }
        } else this.bonus = ''
      }
    },
    wayAmount: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue && newValue !== '') {
          if (this.otcIDs.includes(this.payID) || this.mdTraditionalIDs.includes(this.payID)) {
            return
          }

          if (this.iviMatchPayIDs.includes(this.payID)) {
            const amountIndex = this.filteredWayAmountList().findIndex(amount => amount == newValue)
            if (amountIndex > -1) {
              this.isTrue = amountIndex
            } else {
              this.isTrue = -1
            }
            return
          }

          if (isNaN(newValue) || String(newValue).indexOf('-') >= 0) {
            this.wayAmount = utils
              .roundUp(parseFloat(newValue.replace('-', '')), 0)
              .toFixed(2)
            this.amount = utils
              .accDiv(parseFloat(this.wayAmount), this.rate)
              .toFixed(2)
          }

          if (newValue.toString().split('.')[1]) {
            const fixed = newValue.toString().split('.')[1].length
            if (fixed > 2) {
              newValue
                .toString()
                .split('.')[1]
                .slice(0, 2)

              newValue =
                newValue.toString().split('.')[0] +
                '.' +
                newValue
                  .toString()
                  .split('.')[1]
                  .slice(0, 2)
              this.wayAmount = utils
                .roundUp(parseFloat(newValue), 0)
                .toFixed(2)
              this.amount = utils
                .accDiv(parseFloat(newValue), this.rate)
                .toFixed(2)
            }
          } else {
            this.wayAmount = utils.roundUp(parseFloat(newValue), 0).toFixed(2)
            this.amount = utils
              .accDiv(parseFloat(newValue), this.rate)
              .toFixed(2)
          }
          if (
            this.ruleList &&
            this.ruleList instanceof Array &&
            this.ruleList.length > 0
          ) {
            for (const i in this.ruleList) {
              if (this.ruleList[i].gtBounds !== '') {
                if (this.ruleList[i].ltBounds !== '') {
                  if (this.amount >= parseFloat(this.ruleList[i].gtBounds)) {
                    if (this.amount < parseFloat(this.ruleList[i].ltBounds)) {
                      if (this.ruleList[i].amount !== '') { this.bonus = this.ruleList[i].amount }
                    } else {
                      if (this.ruleList[i].amount !== '') { this.bonus = this.ruleList[i].amount }
                    }
                  }
                } else {
                  if (this.amount >= parseFloat(this.ruleList[i].gtBounds)) {
                    if (this.ruleList[i].amount !== '') { this.bonus = this.ruleList[i].amount }
                  }
                }
              }
            }
          }
          if (this.amount < parseFloat(this.bonusMin[0])) this.bonus = ''
        } else this.bonus = ''
      }
    }
  },
  mounted() {
    this.initMounted()
  },
  activated() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
  },
  methods: {
    initMounted() {
      if (this.rechargeData) this.$store.dispatch('setRechargeData', {})

      this.removeFixed()
      this.$bus.$emit('loading', true)
      window.scrollTo(0, 0)
      // this.AmountSetting()
      this.initMdWayAmounts().then(() => this.MinDepositAmount())
      if (this.pageType === 'app' || this.sourceType === 'old') {
        this.checkFaceValidate()
      }

      this.hasManyDeposit()
      // Reset isButtonCertify = false so that <ButtonCertify> component can re-render
      // after api.depositDataValidate when isButtonCertify = true
      this.isButtonCertify = false
    },
    forceRerenderChildComponents() {
      this.depositAndWithdrawalKey++
    },
    // getUsdtPayIDs(str) {
    //   const obj = JSON.parse(str)
    //   return Object.keys(obj).forEach(function(key) { obj[key] = obj[key].split(',') })
    // },
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    toggleFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.toggle('mainFixed')
    },
    onMouseOver() {
      document.getElementById('inputAmount').classList.add('border')
    },
    onMouseOut() {
      document.getElementById('inputAmount').classList.remove('border')
    },
    clickOpen() {
      this.isOpen = false
      this.payList = this.originalPayList
      this.adjustPayMethods()
    },
    clickClose() {
      this.isOpen = true
      this.payList = JSON.parse(JSON.stringify(this.originalPayList))
      this.adjustPayMethods()
      if (this.payList.length >= 3) {
        this.payList.length = 3
      }
    },
    clickOpenWay() {
      this.isOpenWay = false
      this.wayAmountList = this.originalWayAmountList
    },
    clickCloseWay() {
      this.isOpenWay = true
      this.wayAmountList = JSON.parse(
        JSON.stringify(this.originalWayAmountList)
      )
      if (this.wayAmountList.length >= 8) {
        this.wayAmountList.length = 8
      }
    },
    rechargeNoticePop() {
      this.isRechargeNoticePop = !this.isRechargeNoticePop
    },
    closeBankDictListPop() {
      // this.toggleFixed()
      this.removeFixed()
      this.isBankDictListPop = false
      this.isDictErrMessage = false
      this.isDictExplain = true
      this.isDict = 0
      this.isInput = true
      if (this.otcIDs.includes(this.payID) || this.mdTraditionalIDs.includes(this.payID) || this.mdMatchPayIDs.includes(this.payID)) { // OTC
        return
      }
      this.isWayAmountList = true
      this.isWayAmount = -1
      this.wayAmountList = []
    },
    initMdWayAmounts() {
      this.$bus.$emit('loading', false)
      return api.matchAmountSetting(0).then((res) => {
        this.$bus.$emit('loading', true)
        if (res.data.code == 200) {
          this.mdWayAmounts = res.data.data[0].amounts.map(amount => amount.key)
        }
        return res
      })
    },
    MinDepositAmount() {
      api.getMinDepositAmount().then((res) => {
        // console.log('min deposite:', res)
        if (res.status) {
          if (res.data.code === 200) {
            if (res.data.data.accountLevel) {
              this.accountTxt = this.accountLevelList[
                res.data.data.accountLevel
              ]
            }
            if (res.data.data.minAmount) { this.minAmount = res.data.data.minAmount }
            if (res.data.data.accountGroup === 'T') {
              this.accountSatus = true
              this.accountGroup = 0
            } else {
              this.accountSatus = res.data.data.accountSatus
              this.accountGroup = -1
            }
            this.PaySwitchSeqList()
          }
        }
      })
    },
    AmountSetting() {
      api.getAmountSetting(this.platform).then((res) => {
        // console.log('get amount Setting: ', res)
        if (res.status) {
          if (res.data.code === 200) {
            this.amountList = res.data.data.fixedValueDepositList
            this.ruleList = res.data.data.ruleList
            for (const i in this.ruleList) {
              if (this.ruleList[i].gtBounds !== '') {
                this.bonusMin.push(this.ruleList[i].gtBounds)
              }
            }
            this.bonusMin.sort(function(a, b) {
              return a - b
            })
          }
        }
      })
    },
    checkAmount(amount, index) {
      let amounts
      this.isTrue = index

      if ((this.otcIDs.includes(this.payID) || this.mdTraditionalIDs.includes(this.payID))) { // OTC select ≥3000
        this.wayAmount = ''
        return
      }

      if (this.iviMatchPayIDs.includes(this.payID)) {
        this.wayAmount = amount
        return
      }

      if (this.isWayAmountList) {
        this.amount = parseFloat(amount.fixedAmount).toFixed(2)
        this.bonus = amount.grantAmount
      } else {
        this.wayAmount = utils.roundUp(parseFloat(amount), 0).toFixed(2)
        amounts = utils
          .accDiv(parseFloat(this.wayAmount), this.rate)
          .toFixed(2)
        for (const i in this.amountList) {
          if (i >= 0 && i < this.amountList.length - 1) {
            if (
              amounts > this.amountList[i].fixedAmount &&
              amounts < this.amountList[utils.accAdd(i, 1)].fixedAmount
            ) {
              this.bonus = this.amountList[i].grantAmount
            } else if (amounts === this.amountList[i].fixedAmount) {
              this.bonus = this.amountList[i].grantAmount
            } else if (
              amounts === this.amountList[utils.accAdd(i, 1)].fixedAmount
            ) {
              this.bonus = this.amountList[utils.accAdd(i, 1)].grantAmount
            }
          } else if (i === this.amountList.length) {
            if (amounts >= this.amountList[i].fixedAmount) { this.bonus = this.amountList[i].grantAmount }
          }
        }
      }
    },
    /* icon刷选*/
    picBrush(rawData, brushData) {
      const datas = []
      for (const k in brushData) {
        if (rawData.indexOf(brushData[k].code) >= 0) {
          datas.push(brushData[k].code)
        } else {
          datas.push('other')
        }
      }
      return datas
    },
    /* 支付方式列表*/
    PaySwitchSeqList() {
      api.getPaySwitchSeqList(this.user.loginname).then((res) => {
        // console.log('seq List:', res)
        if (res.status) {
          if (res.data.code === 200) {
            const data = res.data.data
            let flag = false
            /* for (const i in data) {
                if (data[i].code == "micrpay" || data[i].code == "paycoat") {
                    let obj = data[i];
                    data.splice(i, 1);
                    data.splice(0, 0, obj)
                }
            }*/
            this.payLogo = this.picBrush(this.payLogoList, data)
            this.originalPayList = JSON.parse(JSON.stringify(data))
            this.payList = JSON.parse(JSON.stringify(data))
            this.adjustPayMethods()
            for (const i in this.payList) {
              if (this.payList[i].code === 'micrpay' || data[i].code === 'paycoat') {
                flag = true
                this.isHasMicrpay = i
                this.isPay = i
                this.payCode = this.payList[i].code
                this.payID = this.payList[i].id
                this.payName = this.payList[i].paymentGatewayName
                this.PaymentRate(this.payCode, this.payList[i].payCurrency)
              }
            }
            if (!flag) this.isHasMicrpay = -1
            if (this.isHasMicrpay === -1) {
              this.isPay = 0
              this.checkShowAlertPop(this.payList[0])
              this.payCode = this.payList[0].code
              this.payID = this.payList[0].id
              this.payName = this.payList[0].paymentGatewayName
              this.PaymentRate(this.payCode, this.payList[0].payCurrency)

              if (this.mdMatchPayIDs.includes(this.payID) || this.otcIDs.includes(this.payID) || this.mdTraditionalIDs.includes(this.payID)) { // OTC
                this.wayAmountList = this.mdMatchPayIDs.includes(this.payID) ? this.mdWayAmounts : []
                this.isWayAmountList = false
              } else if (this.mdPayIDsMap['200073'].includes(this.payID)) {
                this.wayAmountList = this.mdAltWayAmountsMap['200073']
                this.isWayAmountList = false
              } else if (this.iviMatchPayIDs.includes(this.payID)) {
                this.initMatchAmount()
                this.isWayAmountList = false
              } else if (this.deskZhongYiIDs.includes(this.payID)) {
                this.initAmountList(this.payID)
                this.isWayAmountList = false
              } else {
                this.amountList = this.payList[0].fixedValueDepositList
                this.isTrue = this.payList[0].fixedValueDepositList.findIndex(fixedValueDeposit => fixedValueDeposit.defaultValue === '1')
                this.upperLimit = this.payList[0].upperLimit
                this.lowerLimit = this.payList[0].lowerLimit

                this.PaymentRate(this.payCode, this.payList[0].payCurrency, () => {
                  if (this.payList[0].payCurrency == 'CNY') {
                    this.upperLimit /= Number(this.rate)
                    this.lowerLimit /= Number(this.rate)
                  }
                })
              }

              if (this.payCode === 'ivi_electronic') { this.ivi_deposit(this.payID) }
            }
            // this.originalPayList = JSON.parse(JSON.stringify(data))
            // this.payList = JSON.parse(JSON.stringify(data))
            // this.adjustPayMethods()
            if (this.payList.length >= 3) this.payList.length = 3
            // this.hideOptionInAmountList(this.payCode)
          }
        }
      })
    },
    adjustPayMethods() {
      const payMethodsToAdjust = this.payList.filter(payMethod => this.usdtPayIDsList.includes(payMethod.id))
      if (payMethodsToAdjust.length <= 0) {
        return
      }

      for (const [key, value] of Object.entries(this.usdtPayIDsMap)) {
        this.createPayMethodGroup(key, value)
      }
    },
    createPayMethodGroup(key, payMethodIds) {
      const displayName = key

      const payIndex = this.payList.findIndex(payMethod => payMethod.id === payMethodIds[0])

      const payList = this.payList.filter(payMethod => !payMethodIds.includes(payMethod.id))
      const payMethods = this.payList.filter(payMethod => payMethodIds.includes(payMethod.id))

      if (payMethods.length <= 0) {
        return
      }

      payList.splice(
        payIndex,
        0,
        {
          id: displayName,
          activateAccountEnable: payMethods[0].activateAccountEnable,
          activateAccountSort: payMethods[0].activateAccountSort,
          businessType: payMethods[0].businessType,
          callbackUrl: payMethods[0].callbackUrl,
          channel: payMethods[0].channel,
          code: payMethods[0].code,
          companyId: payMethods[0].companyId,
          createDate: payMethods[0].createDate,
          createIp: payMethods[0].createIp,
          createUser: payMethods[0].createUser,
          deleted: payMethods[0].deleted,
          depositDecimalPlace: payMethods[0].depositDecimalPlace,
          depositRoundingMode: payMethods[0].depositRoundingMode,
          deviceType: payMethods[0].deviceType,
          enable: payMethods[0].enable,
          foDisplayNameCn: displayName,
          foDisplayNameEn: displayName,
          foDisplayNameId: displayName,
          foDisplayNameJa: displayName,
          foDisplayNameKo: displayName,
          foDisplayNameMy: displayName,
          foDisplayNameOther: displayName,
          foDisplayNameTh: displayName,
          foDisplayNameTw: displayName,
          foDisplayNameVi: displayName,
          foGatewayTag: payMethods[0].foGatewayTag,
          gatewayType: payMethods[0].gatewayType,
          isAllPaySeqTag: payMethods[0].isAllPaySeqTag,
          isAutoUpdateThirdPartyData: payMethods[0].isAutoUpdateThirdPartyData,
          isOpenThirdPartyAccount: payMethods[0].isOpenThirdPartyAccount,
          lowerLimit: payMethods[0].lowerLimit,
          newAccountEnable: payMethods[0].newAccountEnable,
          newAccountSort: payMethods[0].newAccountSort,
          notifyUrl: payMethods[0].notifyUrl,
          payCurrency: '',
          paySwitchConfigId: payMethods[0].paySwitchConfigId,
          paymentGatewayName: displayName,
          paymentMerchantId: payMethods[0].paymentMerchantId,
          paymentType: payMethods[0].paymentType,
          remarkDictTypeUUID: payMethods[0].remarkDictTypeUUID,
          stimulatePaymentFlag: payMethods[0].stimulatePaymentFlag,
          thirdPartyVirtualPayment: payMethods[0].thirdPartyVirtualPayment,
          updateDate: payMethods[0].updateDate,
          updateIp: payMethods[0].updateIp,
          updateUser: payMethods[0].updateUser,
          upperLimit: payMethods[0].upperLimit,
          usable: payMethods[0].usable,
          versionNo: payMethods[0].versionNo,
          bankDictList: payMethods.map(payMethod => {
            return {
              id: payMethod.id,
              code: payMethod.code,
              nameTW: payMethod.foDisplayNameTw,
              sort: 10000,
              name: payMethod.foDisplayNameCn,
              enabledStatus: false,
              url: '',
              currency: '',
              bankAccountNumber: '',
              bqwaytype: '',
              amountList: [],
              maxamount: '',
              usageState: '',
              payCurrency: payMethod.payCurrency
            }
          })
        }
      )

      this.payList = payList
    },
    getProtocolByCurrency(currency) {
      switch (currency) {
        case 'USDTERC':
          return 'ERC'
        case 'USDTBEP':
          return 'BEP'
        case 'USDTTRC':
          return 'TRC'
        default:
          return ''
      }
    },
    isCryptoCoins(currency) {
      const cryptoCoinsMap = ['USDT', 'USDTERC']
      return cryptoCoinsMap.includes(currency)
    },
    checkPayType(obj, index) {
      this.payDictCode = '' // reset payDictCode
      this.isPay = index
      if (obj.id != 'USDT') {
        this.payID = obj.id
        this.payName = obj.paymentGatewayName
      }
      this.payCode = obj.code
      this.isDict = 0
      this.isInput = true
      if (this.mdMatchPayIDs.includes(obj.id) || this.otcIDs.includes(obj.id) || this.mdTraditionalIDs.includes(obj.id)) { // OTC
        this.wayAmountList = this.mdMatchPayIDs.includes(obj.id) ? this.mdWayAmounts : []
        this.isWayAmountList = false
      } else if (this.mdPayIDsMap['200073'].includes(this.payID)) {
        this.wayAmountList = this.mdAltWayAmountsMap['200073']
        this.isWayAmountList = false
      } else if (this.iviMatchPayIDs.includes(obj.id)) {
        this.initMatchAmount()
        this.isWayAmountList = false
      } else if (this.deskZhongYiIDs.includes(obj.id)) {
        this.initAmountList(obj.id)
        this.isWayAmountList = false
      } else {
        this.wayAmountList = []
        this.amountList = obj.fixedValueDepositList
        this.upperLimit = obj.upperLimit
        this.lowerLimit = obj.lowerLimit

        this.PaymentRate(obj.code, obj.payCurrency, () => {
          if (obj.payCurrency == 'CNY') {
            this.upperLimit /= Number(this.rate)
            this.lowerLimit /= Number(this.rate)
          }
        })
        this.isWayAmountList = true
      }
      this.amount = ''
      this.wayAmount = ''
      if (obj.fixedValueDepositList && obj.fixedValueDepositList.length > 0) {
        this.isTrue = obj.fixedValueDepositList.findIndex(fixedValueDeposit => fixedValueDeposit.defaultValue === '1')
      } else {
        this.isTrue = -1
      }
      this.isErrMessage = false
      this.isOpenWay = true
      this.displayCurrency = obj.payCurrency
      const isCoins = this.isCryptoCoins(obj.payCurrency)
      if (isCoins) {
        this.payCurrency = obj.payCurrency
      } else {
        this.payCurrency = ''
      }
      // this.payCurrency = obj.payCurrency
      if (['ivi_electronic', 'ivi_usdt'].includes(this.payCode)) {
        this.ivi_deposit(this.payID)
        this.bankDictList = []
      } else {
        this.allowSubmit = true
      }
      // if(['支付宝掃碼', '支付宝3', '支付宝充值', '支付宝2', '支付寶掃碼', '支付寶3', '支付寶充值', '支付寶2'].includes(obj.paymentGatewayName)){
      //   this.showAlertPop = true
      //   this.alertPopUseSlot = true
      //   this.alertPopContent = 'ivi_electronic'
      //   this.alertPopCustomized.button1Txt = '知道了'
      // }
      // if (this.payCode === 'chinaway' && ['OTC支付', '威易支付3'].includes(obj.paymentGatewayName)) {
      //   this.showAlertPop = true
      //   this.alertPaymentGatewayName = obj.paymentGatewayName
      //   this.alertPopUseSlot = true
      //   this.alertPopContent = 'chinaway_otc'
      //   this.alertPopCustomized.button1Txt = '知道了'
      // }
      // if (this.payCode === 'chinaway_onestop') {
      //   this.showAlertPop = true
      //   this.alertPaymentGatewayName = obj.paymentGatewayName
      //   this.alertPopUseSlot = true
      //   this.alertPopContent = 'chinaway_onestop'
      //   this.alertPopCustomized.button1Txt = '知道了'
      // }

      // if (this.payCode === 'goldenegg') {
      if (String(obj.id).includes('USDT')) {
        this.removeFixed()
        this.payID = obj.id
        this.bankDictList = obj.bankDictList
        this.isWayAmount = -1 // Unselect selected subitem
      }
      // if (this.payCode === 'ivi_usdt') {
      //   this.showAlertPop = true
      //   this.alertPopUseSlot = true
      //   this.alertPopContent = 'ivi_usdt'
      //   this.alertPopCustomized.button1Txt = '知道了'
      // }

      if (obj.channel === 5) {
        this.showAlertPop = false
        this.alertPopUseSlot = false
        this.alertPopContent = ''
        this.alertPopCustomized.button1Txt = ''
      }

      // if (this.otcIDs.includes(obj.id) || this.mdTraditionalIDs.includes(obj.id)) { // OTC
      //   this.showAlertPop = true
      //   this.alertPaymentGatewayName = obj.paymentGatewayName
      //   this.alertPopUseSlot = true
      //   this.alertPopContent = 'chinaway_otc'
      //   this.alertWayAmounts = []
      //   this.alertPopCustomized.button1Txt = '知道了'
      // }

      // if (this.mdMatchPayIDs.includes(obj.id)) {
      //   this.showAlertPop = true
      //   this.alertPaymentGatewayName = obj.paymentGatewayName
      //   this.alertPopUseSlot = true
      //   this.alertPopContent = 'chinaway_otc'
      //   this.alertWayAmounts = this.mdWayAmounts
      //   this.alertPopCustomized.button1Txt = '知道了'
      // }

      this.checkShowAlertPop(obj)
    },
    checkWayType(obj, index) {
      if (this.usdtPayIDsList.includes(obj.id)) {
        this.payID = obj.id
      }

      this.amount = ''
      this.wayAmount = ''
      this.isTrue = -1
      this.bqwaytype = obj.bqwaytype
      this.payName = obj.name
      this.payDictCode = obj.code
      this.bankAccountNumber = obj.bankAccountNumber
      this.isWayAmount = index
      this.wayAmountList = []
      this.isErrMessage = false
      this.isOpenWay = true
      this.wayAmountList = JSON.parse(
        JSON.stringify(this.originalWayAmountList)
      )
      if (this.wayAmountList.length >= 8) {
        this.wayAmountList.length = 8
      }
      if (obj.amountList.length > 0) {
        this.isInput = false
        this.isWayAmountList = false
        this.payCurrency = 'CNY'
        this.wayAmountBrush(obj.amountList)
        // special case for cny selection
        // this.displayCurrency = 'USD'
      } else {
        this.isInput = true
        this.wayAmountList = []
        this.isWayAmountList = true
        this.payCurrency = ''
        this.displayCurrency = 'CNY'
      }

      const isUsdtPay = this.usdtPayIDsList.includes(this.payID);

      // 1. Determine if the warning popup should be shown
      this.$refs.depositPayMethodWarningPopup.show(
        obj.id,
        obj.paymentGatewayName || obj.name
      );

      // 2. Process currency and payment rate updates
      if (isUsdtPay) {
        this.displayCurrency = obj.payCurrency;
        this.payCurrency = obj.payCurrency;
        this.PaymentRate(obj.code, obj.payCurrency);
      }
    },
    checkDictType(obj, index) {
      this.bqwaytype = obj.bqwaytype
      this.payName = obj.name
      this.payDictCode = obj.code
      this.bankAccountNumber = obj.bankAccountNumber
      this.isDict = index
    },
    closeRechargeErr() {
      this.toggleFixed()
      this.isRechargeErr = !this.isRechargeErr
      if (this.rechargeErrCallback) {
        this.rechargeErrCallback()
        this.rechargeErrCallback = null
      }
    },
    closeChinaway() {
      this.toggleFixed()
      this.isChinawayPop = !this.isChinawayPop
    },
    goAddBankCard() {
      this.$bus.$emit('loading', false)
      this.$router.push({ path: '/home/addBankCard', query: { bankType: 1 }})
    },
    getHoldBank() {
      const data = 'listBankList'
      api.getDictInfo(data).then((res) => {
        if (res.status) {
          if (res.data.code === 200) {
            this.bankList = res.data.data.listBankList
            this.isHoldBank = true
          }
        }
      })
    },
    closeHoldBankPop(show) {
      this.isHoldBank = show
    },
    /* 人民币刷选*/
    wayAmountBrush(data) {
      const oldData = []
      for (const i in data) {
        if (this.accountSatus) {
          if (parseFloat(utils.accDiv(data[i], this.rate)) > parseFloat(20)) {
            oldData.push(data[i])
          }
        } else {
          if (
            parseFloat(utils.accDiv(data[i], this.rate)) >
            parseFloat(this.minAmount)
          ) {
            oldData.push(data[i])
          }
        }
      }
      oldData.sort(function(a, b) {
        return b - a
      })
      this.originalWayAmountList = JSON.parse(JSON.stringify(oldData))
      this.wayAmountList = JSON.parse(JSON.stringify(oldData))
      if (this.wayAmountList.length > 0) {
        this.isInput = false
        this.isWayAmountList = false
        this.payCurrency = 'CNY'
        if (this.wayAmountList.length >= 8) {
          this.wayAmountList.length = 8
        }
      } else {
        this.isInput = true
        this.isWayAmountList = true
        this.payCurrency = ''
      }
    },
    /* 新支付首位选择*/
    firstBrush(data) {
      this.bqwaytype = data.bqwaytype
      if (data.name != '') {
        this.payName = data.name
      }
      this.payDictCode = data.code
      this.bankAccountNumber = data.bankAccountNumber
    },
    ivi_deposit(id) {
      this.$bus.$emit('loading', false)
      api.getBankListByPayId(id).then((res) => {
        if (res.status) {
          if (res.data.code === 200) {
            this.$bus.$emit('loading', true)
            if (res.data.data.bankDictList.length > 0) {
              this.allowSubmit = true
              const data = JSON.parse(JSON.stringify(res.data.data.bankDictList))

              if (this.payCode == 'ivi_web') {
                this.firstBrush(data[0])
                this.statusBrush()
                return
              }

              let flag = false
              let flagPay = false
              let flagWeChat = false
              for (const i in data) {
                if (data[i].usageState === 'news') {
                  const obj = data[i]
                  data.splice(i, 1)
                  data.splice(0, 0, obj)
                  this.payDictCode = data[i].code
                  this.payName = data[i].name
                }
              }
              this.bankDictList = data

              if (this.payCode === 'ivi_usdt') {
                this.isWayAmount = -1
                // this.firstBrush(data[0])
                // this.payDictCode = data[0].code
              }

              for (const i in data) {
                if (data[i].usageState === 'news') {
                  flag = true
                  if (this.payCode === 'ivi_electronic') {
                    this.isWayAmount = i
                    if (data[i].amountList.length > 0) {
                      this.isWayAmountList = false
                      this.payCurrency = 'CNY'
                      this.wayAmountBrush(data[i].amountList)
                    } else {
                      this.isInput = true
                      this.isWayAmountList = true
                      this.payCurrency = ''
                    }
                  } else if (this.payCode === 'ivi_usdt') {
                    this.isWayAmount = i
                  } else {
                    this.toggleFixed()
                    this.isDict = i
                    this.isInput = true
                  }

                  // Do not autoselect subitem for ivi usdt payment method
                  if (this.payCode !== 'ivi_usdt') {
                    this.firstBrush(data[i])
                  }
                }
              }
              if (!flag) {
                if (this.payCode === 'ivi_electronic') {
                  for (const i in data) {
                    if (data[i].code === 'alipay_wap') {
                      const obj = data[i]
                      data.splice(i, 1)
                      data.splice(0, 0, obj)
                    }
                  }
                  this.bankDictList = data
                  for (const i in data) {
                    if (data[i].code === 'alipay_wap') {
                      flagPay = true
                      this.isWayAmount = i
                      this.firstBrush(data[i])
                      if (data[i].amountList.length > 0) {
                        this.isWayAmountList = false
                        this.payCurrency = 'CNY'
                        this.wayAmountBrush(data[i].amountList)
                      } else {
                        this.isInput = true
                        this.isWayAmountList = true
                        this.payCurrency = ''
                      }
                    }
                  }
                  if (!flagPay) {
                    for (const i in data) {
                      if (data[i].code === 'wechatpay_wap') {
                        const obj = data[i]
                        data.splice(i, 1)
                        data.splice(0, 0, obj)
                      }
                    }
                    this.bankDictList = data
                    for (const i in data) {
                      if (data[i].code === 'wechatpay_wap') {
                        flagWeChat = true
                        this.isWayAmount = i
                        this.firstBrush(data[i])
                        if (data[i].amountList.length > 0) {
                          this.isWayAmountList = false
                          this.payCurrency = 'CNY'
                          this.wayAmountBrush(data[i].amountList)
                        } else {
                          this.isInput = true
                          this.isWayAmountList = true
                          this.payCurrency = ''
                        }
                      }
                    }
                    if (!flagWeChat) {
                      this.bankDictList = JSON.parse(
                        JSON.stringify(res.data.data.bankDictList)
                      )
                      this.isWayAmount = 0
                      if (this.bankDictList.length > 0) { this.firstBrush(this.bankDictList[0]) }
                      if (
                        this.bankDictList.length > 0 &&
                        this.bankDictList[0].amountList.length > 0
                      ) {
                        this.isWayAmountList = false
                        this.payCurrency = 'CNY'
                        this.wayAmountBrush(this.bankDictList[0].amountList)
                      } else {
                        this.isInput = true
                        this.isWayAmountList = true
                        this.payCurrency = ''
                      }
                    }
                  }
                } else {
                  this.bankDictList = JSON.parse(
                    JSON.stringify(res.data.data.bankDictList)
                  )
                  this.isDict = 0
                  this.isInput = true
                  if (!this.otcIDs.includes(this.payID) && !this.mdTraditionalIDs.includes(this.payID) && !this.mdMatchPayIDs.includes(this.payID)) { // Not OTC
                    this.isWayAmountList = true
                  }
                  this.payCurrency = ''
                  if (this.bankDictList.length > 0) {
                    // this.toggleFixed()
                    // Do not autoselect subitem for ivi usdt payment method
                    if (this.payCode !== 'ivi_usdt') {
                      this.firstBrush(this.bankDictList[0])
                    }
                  }
                }
              }
              if (['ivi_deposit', 'chinaway', 'chinaway_cashier', 'chinaway_scanpay'].includes(this.payCode)) {
                if (this.bankDictList.length <= 0) {
                  this.isChinawayPop = true
                  this.isBankDictListPop = false
                } else {
                  this.isChinawayPop = false
                  this.isBankDictListPop = true
                  this.dictPayLogo = this.picBrush(
                    this.dictPayLogoList,
                    this.bankDictList
                  )
                }
              } else if (this.payCode === 'ivi_electronic') { this.isBankDictListPop = false } else {
                this.isBankDictListPop = false
                this.dictPayLogo = this.picBrush(
                  this.dictPayLogoList,
                  this.bankDictList
                )
              }
            } else {
              // no bank dict list return
              this.bankDictList = []
              this.allowSubmit = false
              // alert('此通道暫不提供服務')
              this.showAlertPop = true
              this.alertPaymentGatewayName = ''
              this.alertPopUseSlot = false
              this.alertPopContent = '抱歉，此通道暂不提供服务'
              this.alertPopCustomized.button1Txt = '知道了'
            }
          }
        }
      })
    },
    PaymentRate(code, payCurrency, callback) {
      const data = {
        code: code,
        depositCurrency: this.currency,
        gatewayCurrency: payCurrency
      }
      api.getPaymentRate(data).then((res) => {
        if (res.status) {
          if (res.data.code === 200) {
            this.rate = parseFloat(res.data.data).toFixed(4)
            if (this.accountSatus) {
              this.amountPlaceholder = '请输入存款金额'
            } else {
              if (this.isWayAmountList) { this.amountPlaceholder = '最少存款' + this.minAmount + '美元' } else {
                this.amountPlaceholder =
                  '最少存款' +
                  utils
                    .roundUp(
                      utils.accMul(parseFloat(this.minAmount), this.rate),
                      0
                    )
                    .toFixed(2) +
                  '人民币'
              }
            }

            if (callback) {
              callback()
            }
          }
        }
      })
    },
    /* 不同状态下最低充值额度刷选*/
    statusBrush() {
      let amounts
      if (this.isWayAmountList) amounts = this.amount
      else amounts = utils.accDiv(this.wayAmount, this.rate).toFixed(2)
      if (this.accountGroup === 0) this.dataValidate()
      else {
        if (this.accountSatus) {
          if (parseFloat(amounts) < parseFloat(20)) {
            this.minAmount = 20
            if (['ivi_deposit', 'chinaway', 'chinaway_cashier', 'chinaway_scanpay'].includes(this.payCode)) {
              this.isDictExplain = false
              this.isErrMessage = false
              this.isDictErrMessage = true
            } else {
              this.isErrMessage = true
              this.isDictErrMessage = false
            }
          } else this.dataValidate()
        } else {
          if (parseFloat(amounts) < parseFloat(this.minAmount)) {
            this.$bus.$emit('loading', true)
            if (['ivi_deposit', 'chinaway', 'chinaway_cashier', 'chinaway_scanpay'].includes(this.payCode)) {
              this.isDictExplain = false
              this.isErrMessage = false
              this.isDictErrMessage = true
            } else {
              this.isErrMessage = true
              this.isDictErrMessage = false
            }
          } else this.dataValidate()
        }
      }
    },
    getFaceVal(data) {
      this.isFaceValidate = data
    },
    checkFaceValidate() {
      if (this.sourceType === 'old') {
        this.isFaceValidate = false
      } else this.isFaceValidate = true
    },
    dataValidate() {
      this.$bus.$emit('loading', false)
      const readyData = this.depositParam
      api.depositDataValidate(readyData).then((res) => {
        if (res.status) {
          if (res.data.code === 200) {
            const data = {
              // amount: this.isWayAmountList
              //   ? this.amount
              //   : utils.accDiv(this.wayAmount, this.rate).toFixed(2),
              amount: this.isWayAmountList
                ? this.amount
                : this.wayAmount,
              amountInUSD: this.isWayAmountList ? this.amount : utils.accDiv(this.wayAmount, this.rate).toFixed(2),
              payMethod: this.payID,
              payName: this.payName,
              bqwaytype: this.bqwaytype,
              payDictCode: this.payDictCode,
              rate: this.rate,
              bankAccountNumber: this.bankAccountNumber,
              gatewayAmount: this.isWayAmountList ? '' : this.wayAmount,
              payCurrency: this.payCurrency
            }
            this.$store.dispatch('setRechargeData', data)
            let amounts
            if (this.isWayAmountList) amounts = this.amount
            else amounts = utils.accDiv(this.wayAmount, this.rate).toFixed(2)
            if (['ivi_deposit', 'ivi_matchpay'].includes(this.payCode)) {
              // this.$fireBase.logEvent('deposit', {
              //   platform_type:
              //     this.pageType === 'app'
              //       ? 'app端'
              //       : this.pageType === 'trade'
              //         ? 'H5交易'
              //         : '用户中心',
              //   deposit_type: this.payName,
              //   time: utils.getThisTime(),
              //   deposit_amount: amounts,
              //   payment_channel: '快捷支付',
              //   url: window.location.href
              // })
              this.$router.push({ path: '/home/rechargeDictConfirm' })
            } else {
              this.$fireBase.logEvent('deposit', {
                platform_type:
                  this.pageType === 'app'
                    ? 'app端'
                    : this.pageType === 'trade'
                      ? 'H5交易'
                      : '用户中心',
                deposit_type: this.payName,
                time: utils.getThisTime(),
                deposit_amount: amounts,
                url: window.location.href
              })
              const displayCurrency = this.displayCurrency
              // console.log(this.payCurrency)
              if (['ivi_usdt', 'ivi_electronic', 'chinaway', 'chinaway_cashier', 'chinaway_scanpay', 'ivi_web'].includes(this.payCode)) {
                this.$router.push({
                  path: '/home/rechargeConfirm',
                  query: { payCode: 1, currency: displayCurrency }
                })
              } else {
                this.$router.push({
                  path: '/home/rechargeConfirm',
                  query: { payCode: 0, currency: displayCurrency }
                })
              }
            }
          } else if (res.data.code === 1011) {
            this.buttonData = res.data.data
            this.isButtonCertify = true
          } else {
            this.toggleFixed()
            this.$bus.$emit('loading', true)
            if (res.data.data === 'needBankCard') {
              this.showAddBankCardAlertPop = true
              return
            }
            this.isRechargeErr = true
            this.rechargeErrTxt = res.data.code_desc
          }
        }
      })
    },
    getPaymentAddress() {
      this.$bus.$emit('loading', false)
      api.getPaymentAddress(this.payID).then((res) => {
        this.$bus.$emit('loading', true)
        if (res.data.code == 200) {
          this.$store.dispatch('setRechargeData', {
            payName: this.payName
          })
          this.$router.push({
            path: '/home/rechargeQRCode',
            query: {
              imgQrCode: res.data.data.gatewayAddress
            }
          })
        } else {
          this.isRechargeErr = true
          this.rechargeErrTxt = `此通道暂不提供服务 (${res.data.code})`
        }
      })
    },
    submitDict() {
      this.statusBrush()
    },
    submit() {
      if (this.isSubmitEnabled()) {
        if (this.usdtPayIDsMap['USDT - 1'].includes(this.payID) ||
            this.usdtPayIDsMap['USDT - 3'].includes(this.payID)) {
          this.getPaymentAddress()
          return
        }

        if (['ivi_deposit', 'chinaway', 'chinaway_cashier', 'chinaway_scanpay', 'ivi_web'].includes(this.payCode)) {
          this.dictPayLogo = []
          this.ivi_deposit(this.payID)
        } else {
          this.statusBrush()
        }
      }
    },
    isSubmitEnabled() {
      if (this.otcIDs.includes(this.payID) && this.wayAmount <= 0) { // 云闪付
        return false
      }

      if (this.mdTraditionalIDs.includes(this.payID) && this.wayAmount < 3000) { // OTC支付2
        return false
      }

      if ((this.usdtPayIDsMap['USDT - 1'].includes(this.payID) || this.usdtPayIDsMap['USDT - 3'].includes(this.payID)) && this.isWayAmount >= 0) {
        return true
      }

      if (this.payCode == 'ivi_usdt' && this.payDictCode == '') {
        return false
      }

      return this.isWayAmountList && this.allowSubmit
        ? this.amount != '' && this.amount > 0
        : this.wayAmount != '' && this.wayAmount > 0 && this.allowSubmit
    },
    alertBoxClose() {
      this.showAlertPop = false
      this.alertPopContent = ''
      this.alertPopCustomized.button1Txt = ''
      this.alertPopUseSlot = false
    },
    checkShowAlertPop(obj) {   
      if (!obj.bankDictList) {
        this.$refs.depositPayMethodWarningPopup.show(
          obj.id,
          obj.paymentGatewayName || obj.name
        );
      }
      // this.alertPaymentGatewayName = ''

      // if (['支付宝掃碼', '支付宝3', '支付宝充值', '支付宝2', '支付寶掃碼', '支付寶3', '支付寶充值', '支付寶2'].includes(obj.paymentGatewayName) ||
      //     this.mdPayIDsMap['200217'].includes(obj.id)) {
      //   this.showAlertPop = true
      //   this.alertPaymentGatewayName = obj.paymentGatewayName
      //   this.alertPopUseSlot = true
      //   this.alertPopContent = 'ivi_electronic'
      //   this.alertPopCustomized.button1Txt = '知道了'
      // }

      // if (this.payCode === 'chinaway' && ['OTC支付', '威易支付3'].includes(obj.paymentGatewayName)) {
      //   this.showAlertPop = true
      //   this.alertPaymentGatewayName = obj.paymentGatewayName
      //   this.alertPopUseSlot = true
      //   this.alertPopContent = 'chinaway_otc'
      //   this.alertPopCustomized.button1Txt = '知道了'
      // }
      // // if (this.payCode === 'chinaway_onestop') {
      // //   this.showAlertPop = true
      // //   this.alertPaymentGatewayName = obj.paymentGatewayName
      // //   this.alertPopUseSlot = true
      // //   this.alertPopContent = 'chinaway_onestop'
      // //   this.alertPopCustomized.button1Txt = '知道了'
      // // }

      // if (this.otcIDs.includes(obj.id) ||
      // this.mdTraditionalIDs.includes(obj.id) ||
      // this.mdPayIDsMap['200218'].includes(this.payID) ||
      // this.mdPayIDsMap['200218'].includes(obj.id) ||
      // this.mdPayIDsMap['200203'].includes(this.payID) ||
      // this.mdPayIDsMap['200203'].includes(obj.id)
      // ) { // OTC
      //   this.showAlertPop = true
      //   this.alertPaymentGatewayName = obj.paymentGatewayName
      //   this.alertPopUseSlot = true
      //   this.alertPopContent = 'chinaway_otc'
      //   this.alertWayAmounts = []
      //   this.alertPopCustomized.button1Txt = '知道了'
      // }

      // if (this.mdMatchPayIDs.includes(obj.id)) {
      //   this.showAlertPop = true
      //   this.alertPaymentGatewayName = obj.paymentGatewayName
      //   this.alertPopUseSlot = true
      //   this.alertPopContent = 'chinaway_otc'
      //   this.alertWayAmounts = this.mdWayAmounts
      //   this.alertPopCustomized.button1Txt = '知道了'
      // }

      // if (this.mdPayIDsMap['200216'].includes(this.payID) || this.mdPayIDsMap['200216'].includes(obj.id) || this.mdPayIDsMap['200205'].includes(this.payID) || this.mdPayIDsMap['200205'].includes(obj.id)) {
      //   this.showAlertPop = true
      //   this.alertPaymentGatewayName = obj.paymentGatewayName || obj.name
      //   this.alertPopUseSlot = true
      //   this.alertPopContent = 'md'
      //   this.alertPopCustomized.button1Txt = '知道了'
      // }

      // if (this.mdPayIDsMap['200073'].includes(this.payID) || this.mdPayIDsMap['200073'].includes(obj.id)) {
      //   this.showAlertPop = true
      //   this.alertPaymentGatewayName = obj.paymentGatewayName || obj.name
      //   this.alertPopUseSlot = true
      //   this.alertPopContent = 'md200073'
      //   this.alertPopCustomized.button1Txt = '知道了'
      // }

      // if (this.wechatPayIDs.includes(this.payID) || this.wechatPayIDs.includes(obj.id)) {
      //   this.showAlertPop = true
      //   this.alertPaymentGatewayName = obj.paymentGatewayName || obj.name
      //   this.alertPopUseSlot = true
      //   this.alertPopContent = 'wechatPay'
      //   this.alertPopCustomized.button1Txt = '知道了'
      // }
    },
    initMatchAmount() {
      this.$bus.$emit('loading', false)
      api.matchAmountSetting(0).then((res) => {
        this.$bus.$emit('loading', true)
        if (res.data.code == 200) {
          this.wayAmountList = res.data.data[0].amounts.map(amount => amount.key)
        }
      })
    },
    initAmountList(id) {
      this.$bus.$emit('loading', false)
      api.getBankListByPayId(id).then((res) => {
        this.$bus.$emit('loading', true)
        if (res.data.code == 200) {
          if (res.data.data.bankDictList && res.data.data.bankDictList.length > 0) {
            this.wayAmountList = res.data.data.bankDictList[0].amountList.filter((amount) => utils.accDiv(amount, this.rate).toFixed(2) >= 20)
          } else {
            this.isRechargeErr = true
            this.rechargeErrTxt = '抱歉，此通道暂不提供服务'
            this.rechargeErrCallback = () => {
              this.toggleFixed()
              const currentPayIndex = this.payList.findIndex(payItem => payItem.id == id)
              var nextIndex = currentPayIndex + 1
              if (currentPayIndex >= this.payList.length - 1) {
                nextIndex = 0
              }
              this.isPay = nextIndex
              this.checkPayType(this.payList[nextIndex], nextIndex)
            }
          }
        }
      })
    },
    hasManyDeposit() {
      this.$bus.$emit('loading', false)
      api.hasManyDeposit().then((res) => {
        this.$bus.$emit('loading', true)
        if (res.data.code == 200) {
          const result = res.data.data.result
          this.showHasManyDepositAlertPop = result
        }
      })
    },
    openLive800() {
      var url = `https://onlinecs.cffx139.net/Web/im.aspx?_=t&accountid=137707&visitorid=${new Date().getTime()}`
      var left = (screen.width / 2) - (600 / 2)
      var top = (screen.height / 2) - (400 / 2)
      window.open(url,
        'DescriptiveWindowName',
        'resizable,scrollbars=yes,status=1,width=800, height=550, top=' + top + ', left=' + left)
    },
    onConfirmAccount() {
      this.initMounted()
      this.forceRerenderChildComponents()
    }
  }
}
</script>
